import module from '@app/ui/module'
import template from './template.html'

export class AppUiToolbarComponent {}

module.component('appUiToolbar', {
  controller: AppUiToolbarComponent,
  template: template,
  bindings: {
    search: '<',
    user: '<',
    login: '&',
    logout: '&',
  },
})



// WEBPACK FOOTER //
// ./src/app/ui/components/toolbar/component.js